export function sentenceCase(input: string) {
  const firstLetter = input[0].toUpperCase();
  const rest = input.slice(1).toLowerCase();

  return `${firstLetter}${rest}`;
}

export function titleCase(input: string) {
  const len = input.length;
  let rest = '';

  for (let i = 1; i < len; i++) {
    const previousLetter = input[i - 1];
    const currentLetter = input[i];
    let casedLetter: string;

    if (previousLetter === ' ') {
      casedLetter = currentLetter.toUpperCase();
    } else {
      casedLetter = currentLetter.toLowerCase();
    }

    rest += casedLetter;
  }

  return `${input[0].toUpperCase()}${rest}`;
}

function isUpperCase(letter: string) {
  return letter.toUpperCase() === letter;
}

export function alterCase(input: string) {
  const { length } = input;
  const caseModifier = isUpperCase(input[0])
    ? { even: 'toUpperCase', odd: 'toLowerCase' }
    : { odd: 'toUpperCase', even: 'toLowerCase' };
  let res = '';

  for (let i = 0; i < length; i++) {
    const current = input[i];
    res = res + (i % 2 === 0 ? current[caseModifier.even]() : current[caseModifier.odd]());
  }

  return res;
}

function getRandomInt(max: number) {
  return Math.floor(Math.random() * max);
}

export function randCase(input: string) {
  const caseOptions = ['toUpperCase', 'toLowerCase'];
  const { length } = input;
  let res = '';

  for (let i = 0; i < length; i++) {
    const caseOption = caseOptions[getRandomInt(2)];
    res += input[i][caseOption]();
  }

  return res;
}

export function pascalCase(input: string) {
  const { length } = input;
  let res = '';

  for (let i = 1; i < length; i++) {
    let current: string;

    if (input[i] === ' ') {
      current = '';
    } else if (input[i - 1] === ' ') {
      current = input[i].toUpperCase();
    } else {
      current = input[i].toLowerCase();
    }

    res += current;
  }
  return `${input[0].toUpperCase()}${res}`;
}

function replaceCase(input: string, char: string) {
  return input.replaceAll(' ', char);
}

export function hyphenCase(input: string) {
  return replaceCase(input, '-');
}

export function snakeCase(input: string) {
  return replaceCase(input, '_');
}

export function removePunctuation(input: string) {
  return input.replace(/[^\w\s]|_/g, '');
}
